

export const Parameter = {
    path: '/parameters',
    name: 'parameters',
    component: () => import('@/views/Parameter/ParameterPage.vue'),
    children: [
    ]
}